import { createLocalizationFactory } from "@devowl-wp/utils";
// Only needed once per `window`
let FACTORY_MEMO;
function get() {
    return FACTORY_MEMO ? FACTORY_MEMO : FACTORY_MEMO = createLocalizationFactory("real-thumbnail-generator-lite");
}
const _n = (...args)=>get()._n(...args);
const _nx = (...args)=>get()._nx(...args);
const _x = (...args)=>get()._x(...args);
const __ = (...args)=>get().__(...args);
const _i = (...args)=>get()._i(...args);
export { _n, _nx, _x, __, _i };
